import type { SvgIconComponent } from "@mui/icons-material";
import ApartmentIcon from "@mui/icons-material/Apartment";
import Inventory2Icon from "@mui/icons-material/Inventory2";
import PersonOutlinedIcon from "@mui/icons-material/PersonOutlined";
import SpeedIcon from "@mui/icons-material/Speed";
import TrendingUpIcon from "@mui/icons-material/TrendingUp";

export type ReportPath =
  "sellers-orders" | "sellers-activity" | "customer-comparison" | "customer-details" | "providers";

export interface ReportDefinition {
  readonly path: ReportPath;
  readonly title: string;
  readonly description: string;
  readonly category: "Sprzedaż" | "Klienci" | "Operacje";
  readonly icon: SvgIconComponent;
  readonly color: string;
}

export const REPORTS: Record<ReportPath, ReportDefinition> = {
  "sellers-orders": {
    path: "sellers-orders",
    title: "Sprzedawcy – Zamówienia",
    description:
      "Zamówienia, zaliczki, anulacje, marża i kalkulacje przypisane do sprzedawców — z podziałem na regiony i rankingiem klientów.",
    category: "Sprzedaż",
    icon: TrendingUpIcon,
    color: "#3557a1",
  },
  "sellers-activity": {
    path: "sellers-activity",
    title: "Sprzedawcy – Aktywność",
    description:
      "Spotkania, rozmowy telefoniczne, kalkulacje i nowe zamówienia na podstawie notatek i aktywności sprzedawców.",
    category: "Sprzedaż",
    icon: SpeedIcon,
    color: "#2e7d32",
  },
  "customer-comparison": {
    path: "customer-comparison",
    title: "Klienci — porównanie",
    description: "Metryki zamówień i kalkulacji per klient — domyślnie porównanie bieżącego roku z poprzednim.",
    category: "Klienci",
    icon: ApartmentIcon,
    color: "#1565c0",
  },
  "customer-details": {
    path: "customer-details",
    title: "Klient — raport szczegółowy",
    description:
      "Statystyki jednego wybranego klienta w wybranym okresie — KPI zamówień i wykres trendu z podziałem dzień / miesiąc / rok.",
    category: "Klienci",
    icon: PersonOutlinedIcon,
    color: "#00838f",
  },
  providers: {
    path: "providers",
    title: "Dostawcy",
    description: "Wolumen rezerwacji, zaliczki, anulacje i wskaźniki realnych anulacji per dostawca produktów.",
    category: "Operacje",
    icon: Inventory2Icon,
    color: "#ef6c00",
  },
};

/** `color` with an 8% alpha channel, for tinted icon tiles. */
export function tint(color: string): string {
  return `${color}14`;
}
